var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiploma1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61111 4H4.22222C2.99492 4 2 5.02335 2 6.28571V7.71429C3.99436 7.71429 5.61111 6.05134 5.61111 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.42857C4.91484 9.42857 7.27778 6.99812 7.27778 4H16.7222C16.7222 6.99812 19.0852 9.42857 22 9.42857V14.5714C19.0852 14.5714 16.7222 17.0019 16.7222 20H7.27778C7.27778 17.0019 4.91484 14.5714 2 14.5714V9.42857ZM12.3545 7.67769C12.2188 7.34553 11.7812 7.34553 11.6455 7.67769L10.6591 10.0933C10.6029 10.231 10.4822 10.3254 10.3433 10.3404L7.90461 10.604C7.56929 10.6402 7.43404 11.0884 7.68553 11.3299L9.51454 13.0865C9.61874 13.1866 9.66483 13.3393 9.63516 13.4862L9.11443 16.0648C9.04283 16.4193 9.39692 16.6963 9.68799 16.5134L11.8048 15.1834C11.9254 15.1076 12.0746 15.1076 12.1952 15.1834L14.312 16.5134C14.6031 16.6963 14.9572 16.4193 14.8856 16.0648L14.3648 13.4862C14.3352 13.3393 14.3813 13.1866 14.4855 13.0865L16.3145 11.3299C16.566 11.0884 16.4307 10.6402 16.0954 10.604L13.6567 10.3404C13.5178 10.3254 13.3971 10.231 13.3409 10.0933L12.3545 7.67769Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.7143V16.2857C3.99436 16.2857 5.61111 17.9487 5.61111 20H4.22222C2.99492 20 2 18.9767 2 17.7143Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7778 20H18.3889C18.3889 17.9487 20.0056 16.2857 22 16.2857V17.7143C22 18.9767 21.0051 20 19.7778 20Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.71429V6.28571C22 5.02335 21.0051 4 19.7778 4H18.3889C18.3889 6.05134 20.0056 7.71429 22 7.71429Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiploma1);
export default __webpack_public_path__ + "static/media/diploma-1.a61a15cfebd99bc5f2f5b8dc6c9ddf92.svg";
export { ForwardRef as ReactComponent };